import { fetcher } from '../utils'
import { ComponentUserVO } from '@repo/types'

export default async (input: ComponentUserVO): Promise<void> => fetcher(`/api/user/update`, 'POST', input)
